import React from "react";
import * as styles from "./InlineImage.module.scss";
import classNames from "classnames/bind";
import {
  ResponsiveSanityImage,
  SanityImageRatio,
  ResponsiveSanityImageProps
} from "@silversea-ssc/ui-components-react";

const cx = classNames.bind(styles);

interface InlineImageProps {
  align: "left" | "center" | "right";
  asset: { _ref: string; _type: "reference" };
  width: "quarter" | "third" | "half" | "full";
}

const InlineImage: React.FC<InlineImageProps> = ({ align, asset, width }) => {
  if (!asset) return null;
  if (!asset._ref) return null;

  const image: ResponsiveSanityImageProps["image"] = {
    asset: {
      _id: asset._ref
    }
  };

  return (
    <div
      className={cx({
        inlineImage: true,
        alignLeft: align == "left",
        alignCenter: align == "center",
        alignRight: align == "right",
        widthQuarter: width == "quarter",
        widthThird: width == "third",
        widthHalf: width == "half",
        widthFull: width == "full"
      })}
    >
      <SanityImageRatio image={image} ratio="auto">
        <ResponsiveSanityImage
          image={image}
          defaultWidth={800}
          defaultHeight={600}
        />
      </SanityImageRatio>
    </div>
  );
};

export default InlineImage;
